module.exports = __webpack_public_path__ + "static/Reign_and_Ruin_Sell_Sheet-03857d1f540d403154a95ce964ac20f1.pdf";